import React, { useEffect, useState } from "react";
import { Card, Form } from "react-bootstrap";
import Select from "react-select";

import useMessage from "hooks/useMessage";
import { AnulacionManager } from "managers";
import useExceptionHandler from "hooks/useExceptionHandler";
import EditHeader from "components/PantallasEdit/Header/EditHeader";
import SectionRow from "components/PantallasEdit/SectionRow/SectionRow";
import { ComprobanteElectronico } from "models/ECF/ComprobanteElectronico";
import EditContainer from "components/PantallasEdit/EditContainer/EditContainer";
import InputContainer from "components/PantallasEdit/InputContainer/InputContainer";

export default function AnulacionEdit({ showLoading, hideLoading }) {
  const [anulacion, setAnulacion] = useState({});
  const [saved, setSaved] = useState(false);

  const { Message, cerrarAlertas, Types } = useMessage();
  const { handleException } = useExceptionHandler();

  useEffect(() => {
    return () => {
      cerrarAlertas();
      hideLoading();
    };
  }, []);

  function grabar() {
    if (!saved) {
      showLoading();
      AnulacionManager.crear(anulacion)
        .then((res) => {
          switch (res.Codigo) {
            case "15":
              Message({ message: "Secuencias anuladas satisfactoriamente." });
              break;
            case "01000021":
              Message({ message: "Las secuencias fueron anuladas, pero existen secuencias que ya fueron anuladas anteriormente." });
              break;
            case "19":
              Message({ message: "Las secuencias que intenta anular ya fueron anuladas.", type: Types.TYPE_WARNING });
              break;
            default:
              Message({ message: "Proceso completado." });
              break;
          }
          setSaved(true);
        })
        .catch((e) => handleException(e))
        .finally(() => hideLoading());
    } else {
      Message({
        message: `La entidad ya fue grabada.`,
        type: Types.TYPE_WARNING,
      });
    }
  }

const onSecuenciaChange = (propName, value) => {
  const numValue = parseInt(value, 10);

  const desde =
    propName === "SecuenciaDesde"
      ? numValue
      : parseInt(anulacion.SecuenciaDesde, 10);

  const hasta =
    propName === "SecuenciaHasta"
      ? numValue
      : parseInt(anulacion.SecuenciaHasta, 10);

  let cantidad = 0;

  if (!isNaN(desde) && !isNaN(hasta) && hasta >= desde) {
    cantidad = hasta - desde + 1;
  }

  setAnulacion({
    ...anulacion,
    [propName]: isNaN(numValue) ? "" : numValue,
    CantidadeNCFAnulados: cantidad,
  });
};

  return (
    <>
      <Form action="" className="form-horizontal" method="">
        <Card>
          <EditHeader
            titulo="Anulación de e-NCF"
            volver={true}
            grabar={grabar}
          />
          <EditContainer>
            <SectionRow>
              <InputContainer label="Tipo de Comprobante">
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  name="selectTipoComprobante"
                  menuPosition="fixed"
                  menuPlacement="auto"
                  placeholder="Tipo Comprobante"
                  options={ComprobanteElectronico.tipoComprobanteList}
                  value={ComprobanteElectronico.tipoComprobanteList.filter(
                    (opt) => opt.value === anulacion.TipoComprobante
                  )}
                  onChange={(e) => {
                    setAnulacion({
                      ...anulacion,
                      TipoComprobante: e.value,
                    });
                  }}
                />
              </InputContainer>
            </SectionRow>
            <SectionRow>
              <InputContainer label="Desde">
                <Form.Control
                  type="number"
                  name="SecuenciaDesde"
                  value={anulacion.SecuenciaDesde}
                  onChange={(e) =>
                    onSecuenciaChange(e.target.name, e.target.value)
                  }
                />
              </InputContainer>
              <InputContainer label="Hasta">
                <Form.Control
                  type="number"
                  name="SecuenciaHasta"
                  value={anulacion.SecuenciaHasta}
                  onChange={(e) =>
                    onSecuenciaChange(e.target.name, e.target.value)
                  }
                />
              </InputContainer>
            </SectionRow>
            <SectionRow>
              <InputContainer label="Cantidad de NCF anulados">
                <Form.Control
                  type="number"
                  name="CantidadeNCFAnulados"
                  value={anulacion.CantidadeNCFAnulados}
                  readOnly
                />
              </InputContainer>
            </SectionRow>
          </EditContainer>
        </Card>
      </Form>
    </>
  );
}
